/**
 Author - Muhamed Afsal
 Git - https://bitbucket.org/mohdafsal/
 **/

import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import {SecondaryText} from "../Text";

import {
  openScheduler,
  WealthyEnv
} from "helpers";
import {colors} from "nxtconstants";

const propTypes = {
  contentId: PropTypes.number
};

const defaultProps = {
  contentId: 0
};

const CtaBanner = ({contentId}) => {
  const isPrimary = contentId % 2 === 0;
  let bannerText = "Get your Portfolio Reviewed by a Trained Wealth Manager";
  let bannerBtnLabel = "Schedule a Free Call";
  let bannerBtnId = "gm-schedule-meeting-banner";

  if (isPrimary) {
    bannerText = "Become our Wealth Partner";
    bannerBtnLabel = "Join Us";
    bannerBtnId = "gm-download-app-banner";
  }

  const onClickHandler = (e) => {
    if (isPrimary) {
      window.open(`${WealthyEnv.PARTNER_APP_DEEP_LINK}`);
    } else {
      initCalendly(e);
    }
  };

  const initCalendly = (e) => {
    const {name: route} = e.currentTarget;
    const baseURL = `${WealthyEnv.CALENDLY_URL}/team-wealthy`;
    openScheduler(`${baseURL}/${route}`);
  };

  return (
    <CtaBannerContainer onClick={onClickHandler} >
      <CtaBannerContent>
        <CtaBannerText>
          {bannerText}
        </CtaBannerText>
        <CtaBannerButton
          id={bannerBtnId}
          name="free-call"
          onClick={onClickHandler}
        >
          {bannerBtnLabel}
        </CtaBannerButton>
      </CtaBannerContent>
    </CtaBannerContainer>
  );
};

const CtaBannerContainer = styled.div`
  grid-column: 3 / 11;
  width: 100%;
  display: grid;
  margin-bottom: 5rem;
  grid-template-columns: repeat(12, 1fr);
  cursor: pointer;

  @media (max-width: 48em) {
    grid-column: 1 / 13;
    margin-bottom: 10rem;
  }
`;

const CtaBannerContent = styled.div`
  grid-column: 2 / 12;
  width: 100%;
  background: linear-gradient(to right,#E42E6E 65% ,#bc4e9c);
  color: ${colors.white};
  padding: 5rem 3rem;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 48em) {
    flex-direction: column;
    padding: 3rem;
  }
`;

const CtaBannerText = styled(SecondaryText)`
  color: ${colors.white};
  font-size: 2rem;
  line-height: 1.5;
  text-align: left;

  @media (max-width: 48em) {
    font-size: 1.6rem;
    text-align: center;
    max-width: 220px;
  }
`;

const CtaBannerButton = styled.button`
  background: ${colors.white};
  border: none;
  color: ${colors.amaranth};
  font-size: 1.2rem;
  padding: 1rem 1.5rem;
  font-family: Avenir-Medium;
  text-transform: uppercase;
  cursor: pointer;
  min-width: 140px;
  margin-left: 2rem;

  @media (max-width: 48em) {
    font-size: 1.1rem;
    margin-top: 2rem;
    margin-left: 0;
    min-width: unset;
  }
`;

CtaBanner.propTypes = propTypes;
CtaBanner.defaultProps = defaultProps;

export default CtaBanner;
